import { render } from "./DescListByTaskView.vue?vue&type=template&id=5d587751&scoped=true"
import script from "./DescListByTaskView.vue?vue&type=script&lang=js"
export * from "./DescListByTaskView.vue?vue&type=script&lang=js"

import "./DescListByTaskView.vue?vue&type=style&index=0&id=5d587751&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d587751"]])

export default __exports__